import { useEffect, useState } from "react";

import { SITE_STYLESHEET } from "../site-css.generated";

let ready = false;
let loading: Promise<void> | null = null;

function loadStylesheet() {
  loading ??= new Promise<void>((resolve) => {
    const done = () => {
      ready = true;
      resolve();
    };
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = SITE_STYLESHEET;
    link.addEventListener("load", done, { once: true });
    link.addEventListener("error", done, { once: true });
    // Appended last so it wins over the original app's Tailwind v3 styles.
    document.head.appendChild(link);
  });
  return loading;
}

export function useSiteStylesheet() {
  const [loaded, setLoaded] = useState(ready);

  useEffect(() => {
    if (loaded) return;
    let active = true;
    loadStylesheet().then(() => {
      if (active) setLoaded(true);
    });
    return () => {
      active = false;
    };
  }, [loaded]);

  return loaded;
}
